import React,{ useEffect } from 'react'
import { Stack, Autocomplete, TextField, FormLabel } from '@mui/material';
import Layout from "../../components/core/Layout";
import styles from "./brandDetailsPage.module.scss";
import { getBrandInvoices } from "../../apis/brand-api";
import { useParams } from 'react-router-dom';
import { InvoiceListResponseData, InvoiceDetailsResponseData } from "../../apis/models/InvoiceMasterRequest";
import { getInvoiceDetails } from '../../apis/invmaster-api';
import BillingListAccordion from "../../components/BrandDetailsPage/BillingListAccordion";
import { useLocation } from "react-router-dom";
import { brandInfo } from "../../libs/types";
import { InvStatus } from '../../libs/constants';



const BrandDetails = () => {
    const now = new Date();
    const nowYear = new Date(now.getFullYear());
    const startYear = new Date(2022);
    let years:number[] =[]
    for(let d = startYear; d <= nowYear; d.setDate(d.getDate()+1)) {
        years.push(Number(d));
    }

    const months = [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12
    ]
    const { id } = useParams();
    const [invoiceList, setInvoiceList] = React.useState<InvoiceListResponseData[]>([]);
    const [searchMonth, setSearchMonth] = React.useState<number | null>(null);
    const [searchYear, setSearchYear] = React.useState<number | null>(null);
    const location = useLocation()
    const [info] = React.useState<brandInfo>(location.state as brandInfo);
    const [expanded, setExpanded] = React.useState<string | false>(false);

    const handleAccordionChange = (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
        setExpanded(newExpanded ? panel : false);
    }

    const getInvoiceList = () => {
        if (id !== undefined) {
            getBrandInvoices(id)
            .then((response) => {
                const resBrandInvoices: InvoiceListResponseData[] = response.data.data
                resBrandInvoices.forEach((invoice: InvoiceListResponseData, index: number) => {
                    getInvoiceDetails(invoice.invoiceMasterId)
                    .then((response) => {
                        const resInvoiceDtails: InvoiceDetailsResponseData[] = response.data.data
                        resBrandInvoices[index].details = resInvoiceDtails
                        setInvoiceList(resBrandInvoices);
                    })
                    .catch((error) => {
                        console.log(error);
                    })
                })
                
            })
            .catch((error) => {
                console.log(error);
            });
        }
    }

    const onChangeInvStatus = (inputIndex:number, status: InvStatus) => {
        setInvoiceList((prevState) => prevState.map((obj, index) => (index === inputIndex ? { ...obj, status: status} : obj)));
    }

    useEffect(() => {
        getInvoiceList();        
    },[])

    useEffect(() => {
        if (invoiceList.length !== 0) {
            if (invoiceList[0].details !== undefined) {
                setExpanded("panel0");
            }
        }
    }, [invoiceList])


    return (
    <Layout withBreadcrumbs={true}>
        <div className={styles.PageTop}>
            <Stack className={styles.TitleCompany} direction="row" alignItems="flex-end">
                <div className={styles.brandName}>{info.brandName}</div>
                <div className={styles.brandNo}>(No. {info.brandNo})</div>
                <div className={styles.cutoffDate}>{info.cutoffDate === 31 ? "月末請求" : info.cutoffDate }</div>
                <div className={styles.staff}>担当者：{info.staffName}</div>
            </Stack>
            <div className={styles.billingDate}>
                <Stack direction="row" spacing={2}>
                    <div>
                        <FormLabel>請求年</FormLabel>
                        <Autocomplete
                            disablePortal
                            options={years}
                            sx={{ width:"120px" }}
                            renderInput={(params) => <TextField {...params} />}
                            onChange={(event: any, newValue: number | null) => {
                                setSearchYear(newValue);
                            }}
                        />
                    </div>
                    <div>
                        <FormLabel>請求月</FormLabel>
                        <Autocomplete
                            disablePortal
                            options={months}
                            sx={{ width:"120px" }}
                            renderInput={(params) => <TextField {...params} />}
                            onChange={(event: any, newValue: number | null) => {
                                setSearchMonth(newValue);
                            }}
                        />
                    </div>
                </Stack>
            </div>
            <div className={styles.billingList}>
                {
                    invoiceList.map((item, index) => {
                        return(
                            searchYear === null && searchMonth === null ?
                                <BillingListAccordion key={index} item={item} index={index} expanded={expanded} onChangeInvStatus={onChangeInvStatus} handleAccordionChange={handleAccordionChange} />
                            :searchYear !== null && searchMonth !== null ?
                                Number(item.year) === searchYear && Number(item.month) === searchMonth ?
                                <BillingListAccordion key={index} item={item} index={index} expanded={expanded} onChangeInvStatus={onChangeInvStatus} handleAccordionChange={handleAccordionChange} />
                                    :<></>
                            : Number(item.year) === searchYear || Number(item.month) === searchMonth ? 
                            <BillingListAccordion key={index} item={item} index={index} expanded={expanded} onChangeInvStatus={onChangeInvStatus} handleAccordionChange={handleAccordionChange} />
                            :<></>
                    )})
                }
            </div>
        </div>
    </Layout>
    )
}

export default BrandDetails;